import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/(with-common-layout)/(all)/Advantages.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/assets/icons/iconArrow.svg");
;
import(/* webpackMode: "eager", webpackExports: ["ArticleCard"] */ "/app/src/shared/components/articleCard/ui/ArticleCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/shared/components/casesSlider/ui/MobileSlider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HalfPageSlider"] */ "/app/src/shared/components/halfPageSlider/ui/HalfPageSlider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MainContainer"] */ "/app/src/shared/components/mainContainer/ui/MainContainer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Slider"] */ "/app/src/shared/components/reasons2Gis/ui/Slider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollButton"] */ "/app/src/shared/components/scrollButton/ui/ScrollButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SmallCard"] */ "/app/src/shared/components/smallCard/ui/SmallCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Statistics"] */ "/app/src/shared/components/statistics/ui/Statistics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VideoCarousel"] */ "/app/src/shared/components/videoPlayer/ui/VideoCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VideoPlayer"] */ "/app/src/shared/components/videoPlayer/ui/VideoPlayer.tsx");
